export default __webpack_public_path__ + "static/media/IMG_20230720_075114_580.0aa90b02.jpg";